jQuery(document).ready(function($){
	// Prevent scrolling when mobile menu is open
	$('.navbar-toggler').click( function () {
		$('body').toggleClass('prevent-scroll');
	})
	if ( $(window).width() <= 768 ) {

  	//open menu on click, expand dropdown menu
  	$('#menuToggle').click(function(e){
			$('.navbar-wrapper').toggleClass('active');
			$('.dropdown-menu').addClass('show');
		});

  	$('.nav-link').click(function(){
		$("#navbarNavDropdown").removeClass("show");
	  $("button.navbar-toggler").addClass("collapsed");
	  $("button.navbar-toggler").attr("aria-expanded","false");
	});

	// $('.nav-menu .menu-item-has-children').on("click", function(e){
  //   e.stopPropagation();
  //   if( $(this).is("li") ){
  //     if( $(this).hasClass('opened') ){
  //       $(this).addClass('closed');
  //     } else {
  //     	$(this).removeClass('closed');
  //   	}
  //     $(this).siblings().children('.sub-menu').removeClass('visible');
  //     $(this).siblings().removeClass('current-menu-parent opened');
  //     $(this).toggleClass('current-menu-parent opened');
  //     $(this).children('.sub-menu').toggleClass('visible');
  //   } else {
  //     if( $(this).parent().hasClass('opened') ) {
  //       $(this).parent().addClass('closed');
  //     } else { 
  //     	$(this).parent().removeClass('closed');
  //     }
  //     $(this).parent().siblings().children('.sub-menu').removeClass('visible');
  //     $(this).parent().siblings().removeClass('current-menu-parent');
  //     $(this).parent().children('.sub-menu').toggleClass('visible');
  //     $(this).parent().toggleClass('current-menu-parent opened');
  //   }
  // });

  } else {

  	//open menu on hover for desktop
		$('#menuToggle, #navbarNavDropdown').hover(function(){
			$('.navbar-wrapper').addClass('active');
		}, function(){
			$('.navbar-wrapper').removeClass('active');
		});

		//add dropdown menu toggle functionality to down arrow
		$('.dropdown-toggle.nav-link').append('<a href="#" class="ms-3" data-toggle="dropdown" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-chevron-down"></i></a>');
  	
  	$('.dropdown-toggle.nav-link a').click(function(e){
  		$( this ).toggleClass('active');
  		$( this ).parent().siblings('.dropdown-menu').toggleClass('show');
  	})

  }
  $('.wp-block-navigation__responsive-container-open').click (function (e) {
  	var parentMenus = $('nav li.has-child > a');
  	var hamburgerContainer = $('.nav-column > nav');
  	var openButton = $('button.wp-block-navigation__responsive-container-open');
  	openButton.hide();

  	if ($('.close-container').length === 0) {
  		hamburgerContainer.append('<div class="close-container"></div>')	
  	} else {
  		$('.close-container').show();
  	}
  	var closeButton = $('.close-container');

  	$('.close-container').click (function () {
  		openButton.show();
  		closeButton.hide();
  		$('.wp-block-navigation__responsive-container').removeClass('has-modal-open').removeClass('is-menu-open');
  	})

  	parentMenus.click (function (e) {
  		var target = $(e.target);
  		target.parents('li.has-child').toggleClass('show-submenu');
  		e.preventDefault();
  		var submenu = target.parents('li').find('ul.wp-block-navigation__submenu-container');
    	submenu.toggle();

  	})
  });

	$('.top-bar form label, .top-bar form button, .wp-block-navigation__responsive-container-content label, .wp-block-navigation__responsive-container-content button').click (function (e) {
		var target = $(this);
		var form = target.parents('form');
		var searchBox = form.find('input');

		if (target.hasClass('wp-block-search__button') && form.hasClass('shown') === false && target.parents('.top-bar').length === 0) {
			e.preventDefault();
		}
		form.toggleClass('shown');
	});

  document.addEventListener('click', function(e){
    var btn = e.target.closest('.copy-button');
    if (!btn) return;
    var container = btn.closest('.copy-container');
    var txt = container.querySelector('.copy-text').textContent;
    navigator.clipboard.writeText(txt).then(function(){
      btn.classList.add('copied');
      btn.querySelector('.tooltip').textContent = 'Copied!';
      setTimeout(function(){
        btn.classList.remove('copied');
        btn.querySelector('.tooltip').textContent = 'Click to copy';
      }, 2000);
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
	  const mybutton = document.getElementById("btt");

	  if (mybutton) {
	    // Show/hide on scroll
	    window.addEventListener("scroll", function () {
	      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
	        mybutton.style.display = "block";
	      } else {
	        mybutton.style.display = "none";
	      }
	    });

	    // Scroll to top on click
	    mybutton.addEventListener("click", function () {
	      document.body.scrollTop = 0; // For Safari
	      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	    });
	  }
	});


  // play/pause functionality for full width videos
	$('.block-video-full.new-vid').click (function (e) {
		e.preventDefault(); // <=====================
		var videoBlock = $(this);

		if (videoBlock.hasClass('video-file')) {
			var video = videoBlock;
		} else {
			var video = videoBlock.find('video');
		}
		
		
		video.trigger('play');
		videoBlock.removeClass('new-vid');
		video.attr('controls', true);

	})

	$(document).on('facetwp-loaded', function() {
    $('.facetwp-facet-search .facetwp-icon').hide();
    $('.facetwp-facet-search .facetwp-input-wrap').each(function() {
      if ($(this).find('.facetwp-search-submit').length < 1) {
        $(this).find('.facetwp-search').after('<button class="facetwp-search-submit" onclick="FWP.refresh()">Search</button>');
      }
    });
	});

	$( '.anchor-menu-icon' ).on('click', function(){
		$( '.anchor-menu' ).toggleClass('active');
	});

	$( '.anchor-menu-menu a' ).on('click', function(){
		$( '.anchor-menu' ).removeClass('active');
	});

	gsap.to('.wp-block-cover .wp-block-cover__inner-container p:first-child', {
		delay: 2.5,
		duration: 3,
		opacity: 1,
		y: 0,
		ease: "expo.out",
		scrollTrigger: {
			start: 'top 75%',
			trigger: '.wp-block-cover'
		}
	});

	var splitText = new SplitText(".animated-heading.wp-block-cover .wp-block-cover__inner-container p:last-child", {type: "lines, words", position: 'absolute'});

	let headers = gsap.utils.toArray(splitText.lines);

	function allDone(){
	  splitText.revert();
	}

	gsap.from(splitText.lines, {
		delay: 3,
	  duration: 2,
	  height: 0,
	  opacity: 0,
	  stagger: .3,
	  x: -200,
	  ease: Expo.easeOut,
	  scrollTrigger: {
	    trigger: '.wp-block-cover',
	    start: 'top center',
	    end: 'bottom top',
	    scrub: false
	  }
	});

	//animation for bordered containers
	gsap.registerPlugin(ScrollTrigger);

	let bordersX = gsap.utils.toArray(".animated-border-curtain");

	let tl = gsap.timeline();

	bordersX.forEach((borderX, i) => {
	  tl.to(borderX, {
	    duration: .3,
	    opacity: 1,
	    x: 0,
	    ease: "slow( 0.1, 0.7 )",
	    scrollTrigger: {
	      trigger: borderX,
	      start: 'top center',
	      end: 'bottom center'
	    }
	  });
	});


	//timeline boxes
	function centerOffset(containerEl, bracketEl){
		const H  = containerEl.clientHeight;
		const bh = parseFloat(getComputedStyle(bracketEl).height);
		return (H / 2) - (bh / 2);
	}

	function initCard(card){
		const topB  = card.querySelector(".b--top");
		const botB  = card.querySelector(".b--bottom");
		const inner = card.querySelector(".event-inner");
		const spacer = card.nextElementSibling?.classList.contains("event-spacer")
		? card.nextElementSibling
		: null;

		// initial “meet in middle” + hidden content
		const off = centerOffset(card, topB);
		gsap.set(topB,  { y:  off });
		gsap.set(botB,  { y: -off });
		gsap.set(inner, { opacity: 0, y: 14 });

		// spacer starts collapsed if present
		if (spacer) gsap.set(spacer, { scaleY: 0 });

		const tl = gsap.timeline({
		scrollTrigger: {
			trigger: card,
			start: "top 50%",
			toggleActions: "play none none none",
			once: true,
			onRefresh: self => {
			if (self.progress === 0) {
				const o = centerOffset(card, topB);
				gsap.set(topB, { y:  o });
				gsap.set(botB, { y: -o });
				if (spacer) gsap.set(spacer, { scaleY: 0 });
			}
			}
		},
		defaults: { duration: 0.75, ease: "power3.out" }
		});

		// brackets out + content fade
		tl.to([topB, botB], { y: 0 }, 0)
		.to(inner, { opacity: 1, y: 0, ease: "power2.out" }, 0.05);

		// grow the spacer after the event animates
		if (spacer) {
		tl.to(spacer, {
			duration: 0.55,
			scaleY: 1,
			ease: "power2.out"
		}, ">-0.05"); // start right after content finishes
		}
	}

	const cards = document.querySelectorAll(".timeline-event");
	if (document.readyState === "complete") {
		cards.forEach(initCard);
	} else {
		window.addEventListener("load", () => cards.forEach(initCard));
	}


	//play pause hero video
	$(document).on('click', '.playpause a', function(e){
		e.preventDefault();
		console.log('clicked');
		var video = $(this).closest('.acf-innerblocks-container').find('video').get(0);
		if ( video.paused ) {
			video.play();
			//$(this).removeClass('paused').addClass('playing');
		} else {
			video.pause();
			//$(this).removeClass('playing').addClass('paused');
		}
	});


	
	if ($('.usmap-animation').length > 0) {

		const svg  = document.getElementById('us');
		const dots = Array.from(svg.querySelectorAll('path'));

		// 1) Precompute centers for correct scaling
		dots.forEach(p => {
			const b = p.getBBox();
			p.dataset.svgOrigin = `${b.x + b.width / 2} ${b.y + b.height / 2}`;
		});

		// Shuffle helper for true random order
		function shuffle(arr){
			for (let i = arr.length - 1; i > 0; i--) {
			const j = (Math.random() * (i + 1)) | 0;
			[arr[i], arr[j]] = [arr[j], arr[i]];
			}
			return arr;
		}

		// Build a sub-timeline for the map that *first* sets dots hidden,
		// then reveals the SVG and plays the pop tween.
		function mapTL() {
			const order = shuffle(dots.slice());
			const tl = gsap.timeline();

			// IMPORTANT: set dots' initial state BEFORE revealing the SVG
			tl.set(dots, {
			opacity: 0,
			scale: 0,
			svgOrigin: (i, t) => t.dataset.svgOrigin
			});

			// Now reveal the SVG (no flash because dots are already invisible)
			tl.set(svg, { autoAlpha: 1 });

			// Then run the dot animation
			tl.to(order, {
			opacity: 1,
			scale: 1,
			duration: 0.35,
			ease: "back.out(2)",
			stagger: { each: 5 / order.length } // total ≈ 5s
			});

			return tl;
		}

		// Columns (right-most first)
		const cols = gsap.utils.toArray('.regions-columns .wp-block-column').reverse();

		// Pre-hide columns (do this in markup/CSS too if you want zero paint before JS)
		gsap.set(cols, { autoAlpha: 0, x: -40 });

		const tl = gsap.timeline({
			scrollTrigger: {
			trigger: ".usmap-animation",
			start: "top 60%",
			once: true
			}
		});

		// 1) Columns animate in
		tl.to(cols, {
			autoAlpha: 1,
			x: 0,
			duration: 1,
			ease: "power2.out",
			stagger: 0.2
		});

		// 2) Map shows and dots pop (no intermediate flash)
		tl.add(mapTL(), ">");
	}



});